// extracted by mini-css-extract-plugin
module.exports = {"channels":"styles_channels__SqWMA","channelsTitle":"styles_channelsTitle__q2_IX typography_ChannelsTitle__E0dN6","channelsList":"styles_channelsList__Jd65B"};